import React, { useState, useEffect } from 'react';
import { Row, Column } from 'carbon-components-react';
import DependentsTable from './dependents-table';
import { BeneficiaryType } from "../../components/enums/beneficiary-type";
import BeneficiaryReview from './beneficiary-review';
import { isObjectModified } from '../../components/property-mapper';

const BeneficiariesReview = ({modifiedArray, unmodifiedArray}) => {
    const [isModified, setIsModified] = useState();
    
    useEffect(() => {
        setIsModified(isObjectModified(modifiedArray, unmodifiedArray));
    }, [modifiedArray, unmodifiedArray]);

    return (  
        <>
        {modifiedArray || unmodifiedArray ?
            <div className='text-xl mb-2'>
            <span className={isModified ? 'text-purple' : 'text-danger'}>Beneficiaries</span>
            <Row>
                <Column sm={{span: 0}} md={{span: 8}} className="p-0"> 
                    <DependentsTable modifiedArray={modifiedArray?.filter(s => s.type === BeneficiaryType.Primary)} unmodifiedArray={unmodifiedArray?.filter(s => s.type === BeneficiaryType.Primary)} isBeneficaries={true} type={BeneficiaryType.Primary} />
                    <DependentsTable modifiedArray={modifiedArray?.filter(s => s.type === BeneficiaryType.Contingent)} unmodifiedArray={unmodifiedArray?.filter(s => s.type === BeneficiaryType.Contingent)} isBeneficaries={true} type={BeneficiaryType.Contingent} />
                    <hr className='mt-4' />
                </Column>
                <Column md={{span:0}}>
                    {modifiedArray?.map((modified) => {
                        const unmodified = unmodifiedArray?.find(s => s.id === modified.id);
                    return(
                            <div key={modified.id}>
                                <BeneficiaryReview modified={modified} unmodified={unmodified} />
                            </div>
                    );
                    }
                    )}
                    {
                        unmodifiedArray?.filter(o=> !modifiedArray.some(i=> i.id === o.id))?.map((removed) =>
                        <div key={removed.id} className="line-through text-sm border-solid border my-4 py-3 px-4">
                            {removed?.firstName} {removed?.lastName}
                        </div>
                    )}
                </Column>
            </Row>

            <hr />
        </div> : <></>
    }
        </>
    );
}
 
export default BeneficiariesReview;